import { Batch } from "@wingspanhq/wingspan-api-sdk";

/**
 * Display name for a payable-import batch.
 *
 * v3 `Batch` has no `name` column — the name the user typed on the start screen
 * is stored in `metadata.name` at create time. Batches created before that (or
 * by another client) have no name at all; the fallback deliberately avoids the
 * creation date, which the list renders in its own adjacent column.
 */
export const selectorPayableImportBatchName = (batch: Batch): string =>
  batch.metadata?.name || "Untitled import";
